class SubmissionUploadException extends Error {
  meta: any

  constructor(response: any, field: string, file: Upload.DirectorFile) {
    super(`Error occured uploading ${field}`)

    this.name = 'SubmissionUploadException'
    this.meta = {
      field,
      file,
      response,
    }
  }
}

export default SubmissionUploadException
